import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { GoogleButton } from "../components/PlayButton";
import { Eye, EyeOff } from "lucide-react";

const errText = (d) => d == null ? "Accesso non riuscito" : typeof d === "string" ? d : Array.isArray(d) ? d.map(e => e.msg || JSON.stringify(e)).join(" ") : String(d);

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const next = new URLSearchParams(window.location.search).get("next");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, password);
      toast.success(`Bentornato, ${u.name}`);
      if (next) nav(next);
      else if (u.role === "SUPER_ADMIN") nav("/admin/dashboard");
      else if (u.role === "ORGANIZER" || u.role === "ORGANIZER_ADMIN") nav("/organizer/dashboard");
      else nav("/community");
    } catch (err) {
      setError(errText(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grain-bg">
      <Navbar />
      <div className="pt-28 max-w-md mx-auto px-5">
        <div className="rl-card rl-watermark p-8">
          <img src="/logo-wide.png" alt="Rally Love" className="h-10 mb-5" />
          <div className="pill-badge inline-flex mb-4">ACCEDI</div>
          <h1 className="font-display font-black text-3xl mb-6">Bentornato su Rally Love</h1>
          <form onSubmit={submit} className="space-y-4" noValidate>
            <GoogleButton next={next || "/paddock"} />
            <div>
              <label htmlFor="login-email" className="text-xs font-mono-rl tracking-widest text-slate-400">EMAIL</label>
              <input id="login-email" type="email" name="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input" aria-label="Email"
                className="w-full mt-1 bg-black/40 border border-white/10 rounded-md px-3 py-2.5 min-h-[44px] outline-none focus:border-[#FF1E27]" />
            </div>
            <div>
              <label htmlFor="login-password" className="text-xs font-mono-rl tracking-widest text-slate-400">PASSWORD</label>
              <div className="relative">
                <input id="login-password" type={show ? "text" : "password"} name="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="login-password-input" aria-label="Password"
                  className="w-full mt-1 bg-black/40 border border-white/10 rounded-md px-3 py-2.5 pr-12 min-h-[44px] outline-none focus:border-[#FF1E27]" />
                <button type="button" onClick={() => setShow(s => !s)} aria-label={show ? "Nascondi password" : "Mostra password"} data-testid="login-toggle-password"
                  className="absolute right-1 top-1 h-[44px] w-[44px] flex items-center justify-center text-slate-400 hover:text-white">{show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}</button>
              </div>
              <div className="text-right mt-1"><Link to={`/forgot-password${email ? `?email=${encodeURIComponent(email)}` : ""}`} className="text-xs text-[#FF9F0A] hover:text-white" data-testid="forgot-password-link">Password dimenticata?</Link></div>
            </div>
            {error && <div role="alert" className="text-sm text-[#FF1E27] bg-[#FF1E27]/10 border border-[#FF1E27]/30 rounded-md px-3 py-2" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={busy} data-testid="login-submit-btn" className="btn-crimson w-full min-h-[48px] flex items-center justify-center gap-2" aria-busy={busy}>
              {busy && <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />}{busy ? "Accesso in corso…" : "ACCEDI"}
            </button>
          </form>
          <div className="text-sm text-slate-400 mt-6 text-center">
            Non hai un account? <Link to={`/register${next ? `?next=${encodeURIComponent(next)}` : ""}`} className="text-[#FF9F0A] hover:text-white">Registrati</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
